// Third party packages
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
// Custom packages
import { ApiService } from 'src/app/shared/services/api.service';
import { HelperService } from 'src/app/shared/services/helper.service';
import * as i0 from "@angular/core";
import * as i1 from "./api.service";
import * as i2 from "./helper.service";
var CreditsafeService = /** @class */ (function () {
    /**
     * Class constructor
     */
    function CreditsafeService(apiService, helperService) {
        this.apiService = apiService;
        this.helperService = helperService;
    }
    /**
     * Get an existing company by Vat number
     *
     * @param vatNumber The company Vat number
     *
     * @returns object|null The company data found or null
     */
    CreditsafeService.prototype.getCompanyByVatNumber = function (vatNumber) {
        var _this = this;
        return this.apiService.apiCall('GET', "utils/creditsafe-search-vatnumber?vatNumber=" + vatNumber, {}, {}, true, true).pipe(catchError(function (err) {
            _this.helperService.handleError(err);
            return throwError(err);
        }));
    };
    /**
     * Get an existing company by Name
     *
     * @param companyName The company name
     *
     * @returns object|null The company data found or null
     */
    CreditsafeService.prototype.getCompanyByCompanyName = function (companyName) {
        var _this = this;
        return this.apiService.apiCall('GET', "utils/creditsafe-search-name?name=" + companyName, {}, {}, true, true).pipe(catchError(function (err) {
            _this.helperService.handleError(err);
            return throwError(err);
        }));
    };
    CreditsafeService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CreditsafeService_Factory() { return new CreditsafeService(i0.ɵɵinject(i1.ApiService), i0.ɵɵinject(i2.HelperService)); }, token: CreditsafeService, providedIn: "root" });
    return CreditsafeService;
}());
export { CreditsafeService };
